import { render, staticRenderFns } from "./SessionCountdown.vue?vue&type=template&id=4877431c&scoped=true"
import script from "./SessionCountdown.vue?vue&type=script&lang=js"
export * from "./SessionCountdown.vue?vue&type=script&lang=js"
import style0 from "./SessionCountdown.vue?vue&type=style&index=0&id=4877431c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4877431c",
  null
  
)

export default component.exports